<template>
    <div class="bg">
        <div class="index-top">
            <!-- 顶部信息 -->
            <common-head :active="0" class="head"></common-head>

            <!-- 轮播图信息 -->
            <common-slide class="slide"></common-slide>
        </div>

        <!-- 首页广告 -->
        <index-banner></index-banner>

        <!-- 活动列表 -->
        <index-activity></index-activity>

        <!-- 底部信息 -->
        <common-footer></common-footer>

    </div>
</template>

<script>
    import { site_name } from '@/static/js/common.js';
    import commonHead from '@/components/pc/commonHead.vue';
    import commonFooter from '@/components/pc/commonFooter.vue';
    import commonSlide from '@/components/pc/commonSlide.vue';
    import indexBanner from '@/components/pc/indexBanner.vue';
    import indexActivity from '@/components/pc/indexActivity.vue';

    export default {
        name: 'index',
        components: {
            commonHead, commonFooter, commonSlide, indexBanner, indexActivity,
        },
        data() {
            return {

            }
        },
        metaInfo() {
            site_name().then(res => {
                document.title = '首页-' + res.site_name;
                return {
                    title: '首页-' + res.site_name,
                    meta: [
                        { name: "keywords", content: "" },
                        { name: "description", content: "" },
                        { name: 'viewport', content: 'width=device-width, initial-scale=0, maximum-scale=0, user-scalable=yes,shrink-to-fit=no' }
                    ],
                }
            });
        },
        created() {

        },
        methods: {

        },
    }
</script>
<style scoped lang="less">
    .bg {
        background-color: #f2f2f2;
    }

    .index-top {
        position: relative;
        width: 100%;
        height: 100vh;
    }

    .head {
        z-index: 9999;
        width: 100%;
    }

    .slide {
        width: 100%;
        height: 100vh;
    }
</style>